import React from 'react';

import styles from './styles.module.scss';

const YesNoAnswer = ({ question, item, setSelectedAnswer }) => {
  return <button
    onClick={() => setSelectedAnswer(question, item)}
    className={styles.answer + ' ' + (question.answer ? question.answer?.key === item.key ? styles.selected : styles.unselected : '')}
  >
    <span></span>
    {item.text}
  </button>;
}

export default YesNoAnswer;
